// One shared, compact rhythm for editorial rails. Heavy scroll-reveal
// animations were removed so cards render immediately and do not pop into
// view when a reader scrolls or uses an in-page anchor.
const STEP = "pt-7 px-4 sm:px-6 sm:pt-9 lg:px-8 lg:pt-10 max-w-[1240px] mx-auto";

export function Section({ id = undefined, children, className = "" }) {
  return <section id={id} className={`${STEP} ${className}`}>{children}</section>;
}

export function StaticSection({ id = undefined, children, className = "" }) {
  return <section id={id} className={`${STEP} ${className}`}>{children}</section>;
}
